import instance from "@/app/(dashboard)/(sidebar)/api/api"
import { Customer } from "@/clients/bolta-apis"

import { BaseResponse } from "../types"
import { apiPrivateClient } from "../apiClients"

export type FetchCustomerListApi = {
  Params: Customer.FetchCustomer.RequestParams & Customer.FetchCustomer.RequestQuery
  Response: Customer.FetchCustomer.ResponseBody
}
export const fetchCustomerListApi = async ({
  workspaceId,
  ...params
}: FetchCustomerListApi["Params"]) => {
  const url = `/api/v2/workspaces/${workspaceId}/customers`
  const {
    data: { body },
  } = await instance<BaseResponse<FetchCustomerListApi["Response"]>>({
    method: "GET",
    url,
    params: {
      ...params,
      searchKeyword: params.searchKeyword ? params.searchKeyword.trim() : undefined,
    },
  })
  return body
}

export type FetchCustomerApi = {
  Params: MaybeBy<Customer.RetrieveCustomer.RequestParams, "customerId">
  Response: Customer.RetrieveCustomer.ResponseBody
}
export const fetchCustomerApi = async ({
  workspaceId,
  customerId,
}: FetchCustomerApi["Params"]) => {
  const url = `/api/v2/workspaces/${workspaceId}/customers/${customerId}`
  const {
    data: { body },
  } = await instance<BaseResponse<FetchCustomerApi["Response"]>>({
    method: "GET",
    url,
  })
  return body
}

export type PostCustomerApi = {
  Params: Customer.CreateCustomer.RequestParams & Customer.CreateCustomer.RequestBody
  RequestBody: Customer.CreateCustomer.RequestBody
  Response: Customer.CreateCustomer.ResponseBody
}

export const postCustomerApi = async ({
  workspaceId,
  ...requestBody
}: PostCustomerApi["Params"]) => {
  const url = `/api/v2/workspaces/${workspaceId}/customers`
  const {
    data: { body },
  } = await apiPrivateClient<BaseResponse<PostCustomerApi["Response"]>>({
    method: "POST",
    url,
    data: requestBody,
  })

  return body
}

export type PutCustomerApi = {
  Params: Customer.UpdateCustomer.RequestParams & Customer.UpdateCustomer.RequestBody
  RequestBody: Customer.UpdateCustomer.RequestBody
  Response: Customer.UpdateCustomer.ResponseBody
}

export const putCustomerApi = async ({
  workspaceId,
  customerId,
  ...requestBody
}: PutCustomerApi["Params"]) => {
  const url = `/api/v2/workspaces/${workspaceId}/customers/${customerId}`
  const {
    data: { body },
  } = await apiPrivateClient<BaseResponse<PostCustomerApi["Response"]>>({
    method: "PUT",
    url,
    data: requestBody,
  })

  return body
}
